export const PRICE_PER_TON_IN_CENT = 9900;
export const MINIMUM_WEIGHT_IN_TONS = 2;
